import { createContext } from 'react'

import { createCustomMemberGroupStore } from '../store'

export const CustomMemberGroupStoreContext = createContext<
  ReturnType<typeof createCustomMemberGroupStore> | undefined
>(undefined)
